const links = document.querySelectorAll(".product-content__menu-wrapper a");

for (const link of links) {
    link.addEventListener("click", clickHandler);
}
var allProductsLink = document.getElementById("show-all-products");
if (allProductsLink) {
    allProductsLink.addEventListener("click", clickHandler);
}

function clickHandler(e) {
    e.preventDefault();
    const href = this.getAttribute("href");
    let yOffset = -50;
    if (document.body.clientWidth <= 1023) {
        yOffset = -150;
    }
    const element = document.getElementById(href.replace(/#/g, ""));
    const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
}

let headerRef = document.getElementById("header__top-section");
let headerHeight = document.getElementById("header").offsetHeight;
let menuRef = document.getElementById("product-content__menu-wrapper-row");
let menu = document.getElementById("product-content__menu-container");

if (menu) {
    var y =
        (document.documentElement && document.documentElement.scrollTop) ||
        document.body.scrollTop;
    var checkValue = menuRef.offsetTop - headerHeight;
    if (y >= checkValue) {
        if (headerRef) {
            headerRef.classList.remove("box-shadow");
        }
        menu.classList.add("sticky");
    } else {
        if (headerRef) {
            headerRef.classList.add("box-shadow");
        }
        menu.classList.remove("sticky");
    }

    window.addEventListener("scroll", function () {
        var y =
            (document.documentElement && document.documentElement.scrollTop) ||
            document.body.scrollTop;
        var checkValue = menuRef.offsetTop - headerHeight;
        if (y >= checkValue) {
            if (headerRef) {
                headerRef.classList.remove("box-shadow");
            }
            menu.classList.add("sticky");
        } else {
            if (headerRef) {
                headerRef.classList.add("box-shadow");
            }
            menu.classList.remove("sticky");
        }
    });
}
